import { ParkApi } from 'api'
import { TopLevelPage, ModelGrid } from 'ui'
import { withErrorBoundary, connected, SearchBar } from 'shared'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import useForceUpdate from 'hooks/useForceUpdate'

const Parks = (props) => {
  const queryRef = useRef(ParkApi.paramsFor('index').q)
  const forceUpdate = useForceUpdate()

  const queryDidChange = query => { queryRef.current = query }
  const queryWouldSubmit = () => { forceUpdate() }

  let { id, eventId } = props.match.params
  let validId = !isNaN(id)
  let models = validId ? ParkApi.kick('list', { smart_button_id: id }) : ParkApi.kick('index', { q: queryRef.current })

  let base = validId ? `/parks/${id}` : '/parks'
  let modelId = eventId || id

  return (
    <TopLevelPage className="Parks" modelId={modelId} base={base}>
      { !validId &&
        <div className="row">
          <div className="col-sm-6 col-lg-4 col-xl-3">
            <SearchBar onChange={queryDidChange} onSubmit={queryWouldSubmit} initialQuery={queryRef.current} />
          </div>
        </div>
      }
      <ModelGrid models={models} base={base} />
    </TopLevelPage>
  )
}

Parks.propTypes = {
  match: PropTypes.object
}

export default withErrorBoundary(connected(Parks))
